import * as React from "react";
import { useMutation, Types } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import MERGE_SHOPPING_LISTS from "../../operations/mutations/operations/mutations/merge-shopping-lists.js";
import { useGetMyWishlistId } from "./use-get-my-wishlist-id.js";
const useMergeShoppinglists = () => {
  const { locale } = useIntl();
  const [hasError, setHasError] = React.useState(false);
  const { localWishlist, clearWishlist } = useWishlistId();
  const { id: userWishlistId } = useGetMyWishlistId();
  const localWishlistId = localWishlist?.id;
  const [mutation, { loading, called }] = useMutation(MERGE_SHOPPING_LISTS, {
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    refetchQueries: ["GetShoppingListCount", "GetMyWishlistId", "GetMyWishlist"]
  });
  const mergeShoppinglists = React.useCallback(async () => {
    try {
      if (localWishlistId && localWishlistId !== userWishlistId && !called) {
        const { data } = await mutation({
          variables: {
            input: {
              auxiliaryShoppinglistId: localWishlistId,
              shoppinglistType: Types.ShoppinglistType.WISHLIST,
              mainShoppinglistId: userWishlistId ?? null
            }
          }
        });
        if (data?.mergeShoppinglists.shoppinglist?.id) {
          clearWishlist();
        }
        if (data?.mergeShoppinglists.failure) {
          throw new Error(
            `Merging shopping lists failed: ${data.mergeShoppinglists.failure.message}`
          );
        }
      }
    } catch (e) {
      setHasError(true);
      console.error("Error while merging shopping lists", e);
    }
  }, [called, localWishlistId, userWishlistId, mutation, clearWishlist]);
  return {
    loading,
    error: hasError,
    mergeShoppinglists
  };
};
export {
  useMergeShoppinglists
};
//# sourceMappingURL=use-merge-shopping-lists.js.map
